import { RouterLink } from 'src/lib/router/RouterLink';

const Link = ({ href, children, className }) => {
  return (
    <RouterLink href={href} className={className}>
      {children}
    </RouterLink>
  );
};

export default Link;
